import { useState } from "react";

const responses = [
  "This question looks for the first outline of the room.",
  "This question listens for the protective logic behind the fear.",
  "This question gives the fear a voice without giving it command.",
  "This question turns attention toward the space that opens afterward."
];

function ReflectionPrompt({ questions }) {
  const [activeIndex, setActiveIndex] = useState(0);
  const active = questions[activeIndex];

  return (
    <section>
      <h2 className="font-display text-3xl text-museum-bone">Reflection prompts</h2>
      <div className="mt-4 rounded-lg border border-museum-gold/25 bg-museum-black/45 p-5">
        <p className="text-xs uppercase tracking-[0.24em] text-museum-gold">Selected question</p>
        <p className="mt-3 font-display text-2xl leading-9 text-museum-bone">{active}</p>
        <p className="mt-3 text-sm leading-7 text-museum-muted">{responses[activeIndex]}</p>
      </div>
      <div className="mt-5 grid gap-3 sm:grid-cols-2">
        {questions.map((question, index) => (
          <button
            key={question}
            type="button"
            onClick={() => setActiveIndex(index)}
            aria-pressed={active === question}
            className={`rounded-lg border p-5 text-left text-sm leading-7 transition ${
              active === question
                ? "border-museum-gold bg-museum-gold/10 text-museum-bone"
                : "border-museum-bone/12 bg-museum-panel/45 text-museum-muted hover:border-museum-gold/50 hover:text-museum-bone"
            }`}
          >
            {question}
          </button>
        ))}
      </div>
    </section>
  );
}

export default ReflectionPrompt;
